function isAutoHeight(value) {
  return value == null || value === '' || value === 'auto';
}

function parseSlotPx(value, fallback) {
  const n = Number.parseInt(String(value).replace(/[^\d]/g, ''), 10);
  return Number.isFinite(n) && n > 0 ? n : fallback;
}

export function resolveAdSlotHeightPx(slotHeightPx, minHeightPx = '600px') {
  if (isAutoHeight(slotHeightPx) && isAutoHeight(minHeightPx)) {
    return 120;
  }
  const min = parseSlotPx(minHeightPx, 600);
  if (isAutoHeight(slotHeightPx)) {
    return min;
  }
  return parseSlotPx(slotHeightPx, min);
}

export function adSlotReservedBoxStyle(slotHeightPx, minHeightPx = '600px') {
  if (isAutoHeight(slotHeightPx) && isAutoHeight(minHeightPx)) {
    return { height: 'auto', minHeight: 'auto' };
  }
  const h = resolveAdSlotHeightPx(slotHeightPx, minHeightPx);
  return { minHeight: `${h}px`, height: `${h}px` };
}

export function adSlotContainerStyle({
  slotHeightPx,
  minHeightPx,
  maxHeightPx,
  overflowAuto = false,
}) {
  const hasMax = maxHeightPx != null && !isAutoHeight(maxHeightPx);
  const hasFixedHeight = !isAutoHeight(slotHeightPx);
  const hasMin = !isAutoHeight(minHeightPx);

  if (!hasMax && !hasFixedHeight && !overflowAuto) {
    return adSlotReservedBoxStyle(slotHeightPx, minHeightPx);
  }

  /** @type {Record<string, string>} */
  const style = {};

  if (hasFixedHeight) {
    const h = parseSlotPx(slotHeightPx, 0);
    if (h > 0) {
      style.height = `${h}px`;
      style.minHeight = `${h}px`;
    }
  } else if (hasMin) {
    const min = parseSlotPx(minHeightPx, 0);
    if (min > 0) style.minHeight = `${min}px`;
  }

  if (hasMax) {
    const max = parseSlotPx(maxHeightPx, 0);
    if (max > 0) style.maxHeight = `${max}px`;
  }

  if (overflowAuto) {
    style.overflow = 'auto';
  }

  return style;
}

export function resolveAdSlotSkeletonHeightPx({
  slotHeightPx,
  minHeightPx,
  maxHeightPx,
}) {
  if (!isAutoHeight(slotHeightPx) || !isAutoHeight(minHeightPx)) {
    let h = resolveAdSlotHeightPx(slotHeightPx, minHeightPx);
    if (maxHeightPx != null && !isAutoHeight(maxHeightPx)) {
      h = Math.min(h, parseSlotPx(maxHeightPx, h));
    }
    return h;
  }
  if (maxHeightPx != null && !isAutoHeight(maxHeightPx)) {
    return Math.min(parseSlotPx(maxHeightPx, 500), 320);
  }
  return 120;
}
